const HEADER_CLASS = 'sticky-table-header'

function copyCellSizes(sourceCells, targetCells) {
  sourceCells.forEach((cell, index) => {
    const target = targetCells[index]
    if (!target) return

    const rect = cell.getBoundingClientRect()
    target.style.width = `${rect.width}px`
    target.style.minWidth = `${rect.width}px`
    target.style.maxWidth = `${rect.width}px`
    target.style.height = `${rect.height}px`
  })
}

function createStickyHeader(el) {
  const table = el.querySelector('table')
  const thead = table && table.querySelector('thead')

  if (!table || !thead) return null

  const fixedWrap = document.createElement('div')
  fixedWrap.className = HEADER_CLASS
  fixedWrap.style.display = 'none'

  const scrollPane = document.createElement('div')
  scrollPane.className = `${HEADER_CLASS}__scroll`

  const cloneTable = table.cloneNode(false)
  cloneTable.className = `${table.className} ${HEADER_CLASS}__table`
  cloneTable.appendChild(thead.cloneNode(true))

  scrollPane.appendChild(cloneTable)
  fixedWrap.appendChild(scrollPane)
  document.body.appendChild(fixedWrap)

  const state = {
    el,
    table,
    thead,
    fixedWrap,
    scrollPane,
    cloneTable,
    frame: null
  }

  const update = () => {
    state.frame = null

    if (!document.body.contains(el)) {
      destroyStickyHeader(state)
      return
    }

    const wrapperRect = el.getBoundingClientRect()
    const tableRect = table.getBoundingClientRect()
    const theadRect = thead.getBoundingClientRect()
    const top = 0
    const shouldShow =
      wrapperRect.width > 0 &&
      tableRect.top < top &&
      tableRect.bottom > top + theadRect.height

    if (!shouldShow) {
      fixedWrap.style.display = 'none'
      return
    }

    const sourceCells = Array.from(thead.querySelectorAll('th'))
    const targetCells = Array.from(cloneTable.querySelectorAll('th'))

    copyCellSizes(sourceCells, targetCells)
    cloneTable.style.width = `${tableRect.width}px`
    cloneTable.style.minWidth = `${tableRect.width}px`
    scrollPane.style.transform = `translateX(${-el.scrollLeft}px)`

    fixedWrap.style.display = 'block'
    fixedWrap.style.left = `${wrapperRect.left}px`
    fixedWrap.style.top = `${top}px`
    fixedWrap.style.width = `${wrapperRect.width}px`
    fixedWrap.style.height = `${theadRect.height}px`
  }

  const requestUpdate = () => {
    if (state.frame) return
    state.frame = window.requestAnimationFrame(update)
  }

  state.requestUpdate = requestUpdate
  window.addEventListener('scroll', requestUpdate, true)
  window.addEventListener('resize', requestUpdate)
  el.addEventListener('scroll', requestUpdate)
  requestUpdate()

  return state
}

function destroyStickyHeader(state) {
  if (!state) return

  window.removeEventListener('scroll', state.requestUpdate, true)
  window.removeEventListener('resize', state.requestUpdate)
  state.el.removeEventListener('scroll', state.requestUpdate)

  if (state.frame) {
    window.cancelAnimationFrame(state.frame)
  }

  if (state.fixedWrap && state.fixedWrap.parentNode) {
    state.fixedWrap.parentNode.removeChild(state.fixedWrap)
  }
}

export default {
  inserted(el) {
    el.__stickyTableHeader = createStickyHeader(el)
  },
  componentUpdated(el) {
    if (el.__stickyTableHeader) {
      el.__stickyTableHeader.requestUpdate()
    }
  },
  unbind(el) {
    destroyStickyHeader(el.__stickyTableHeader)
    delete el.__stickyTableHeader
  }
}
